import { FormEvent, useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';

import { addDatadogAction } from '@cartwhl/tracking/datadog';
import { DATADOG_ACTIONS } from '@cartwhl/tracking/datadogConstants';
import PromptInput from '@cartwhl/ui/input/PromptInput';

import { animationGenerationStore, projectStore, uiStore } from 'stores';

import { PLACEHOLDERS, PLACEHOLDERS_SESSION } from '../constants';
import { usePlaceholders } from '../hooks';

export default function TextToMotion() {
  const { jobData, prompt, currentAnimationNumber, videoUpload } = useSnapshot(
    animationGenerationStore.state,
    {
      sync: true,
    },
  );
  const { currentProject } = useSnapshot(projectStore.state);
  const { promptFocus } = useSnapshot(uiStore.state);
  const [submitting, setSubmitting] = useState(false);

  const isPlayerDisabled =
    videoUpload?.status === 'QUEUED' || videoUpload?.status === 'PROCESSING';
  const isGenerating = false; // TODO

  const placeholder = usePlaceholders(
    jobData ? PLACEHOLDERS_SESSION : PLACEHOLDERS,
  );

  const submitJob = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    addDatadogAction(DATADOG_ACTIONS.GENERATE_MOTION);

    setSubmitting(true);
    uiStore.setPromptFocus(false);
    if (currentProject.data) {
      const result = await projectStore.addMotionToCurrentProject({
        prompt,
        numFrames: 0,
        moreVariations: false,
      });
      if (result?.success) {
        animationGenerationStore.setPrompt('');
        uiStore.setMotionFrontDoorMode('project');
      }
    } else {
      const result = await animationGenerationStore.submitJobFromPrompt({
        numFrames: 0,
        prompt,
        moreVariations: false,
        currentAnimationNumber,
      });
      if (result?.success) {
        animationGenerationStore.setPrompt('');
      }
    }
    setSubmitting(false);
  };

  useEffect(() => {
    return () => {
      uiStore.setPromptFocus(false);
    };
  }, []);

  return (
    <PromptInput
      buttonVariant="animate"
      buttonText="Animate"
      placeholder={placeholder}
      prompt={prompt}
      onChange={(e) => animationGenerationStore.setPrompt(e.target.value)}
      onSubmit={submitJob}
      onFocus={() => uiStore.setPromptFocus(true)}
      disabled={submitting || isGenerating || isPlayerDisabled}
      loading={submitting || isGenerating}
      className="rounded-t-2xl rounded-b-lg"
      active={promptFocus}
      datadogActionName={DATADOG_ACTIONS.GENERATE_MOTION}
      textarea
    />
  );
}
